export default __webpack_public_path__ + "static/10-8e9dae0bbf5a28621b516af20a5171d3.webp";